import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/no-data/table-empty.png';
const _withScopeId = n => (_pushScopeId("data-v-40484c44"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "user-page common-page"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "page-title"
}, "用户列表", -1));
const _hoisted_3 = {
  class: "search-form"
};
const _hoisted_4 = {
  class: "user-table"
};
const _hoisted_5 = {
  key: 0,
  class: "message-dialog"
};
const _hoisted_6 = {
  class: "message-item"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item-label"
}, "昵称", -1));
const _hoisted_8 = {
  class: "item-text"
};
const _hoisted_9 = {
  class: "message-item"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item-label"
}, "姓名", -1));
const _hoisted_11 = {
  class: "item-text"
};
const _hoisted_12 = {
  class: "message-item"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item-label"
}, "手机号码", -1));
const _hoisted_14 = {
  class: "item-text"
};
const _hoisted_15 = {
  key: 1,
  style: {
    "color": "#666",
    "text-align": "center"
  }
};
const _hoisted_16 = {
  key: 0
};
const _hoisted_17 = {
  key: 1
};
const _hoisted_18 = {
  style: {
    "color": "#F56C6C"
  }
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "table-empty"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "no-data",
  src: _imports_0,
  alt: ""
}), /*#__PURE__*/_createElementVNode("div", {
  class: "empty-text"
}, "暂无数据")], -1));
import { reactive, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { getUserListApi, getParentInfoApi, getSourceGroupApi } from "@/service/modules/user";
import { addLoading } from "@/utils/element-method";
import protoPagination from "@/components/proto-pagination.vue";
import userDialog from "./components/user-dialog.vue";
import parentMessageDialog from "./components/parent-message-dialog.vue";
import { ElMessage } from "element-plus";
export default /*#__PURE__*/_defineComponent({
  __name: 'user',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const userList = ref([]);
    const userTableFirst = ref(true);
    const sourceGroupList = ref([]);
    const cascaderProps = {
      checkStrictly: true,
      label: "name",
      value: "id"
    };
    const total = ref(0);
    const parentInfo = ref(null);
    const userForm = reactive({
      openid: "",
      group1_id: [],
      mobile: "",
      time: [],
      is_staff: 0,
      time_type: null
    });
    const page = reactive({
      page: 1,
      pageSize: 15
    });
    const userDialogVisible = ref(false);
    const userDialogData = ref();
    const parentDialogVisible = ref(false);
    const parentDialogData = ref({});
    const parentLoading = ref(false);
    getUserList();
    async function getUserList() {
      let params = {
        ...userForm,
        ...page
      };
      Object.keys(params).forEach(key => {
        if (!params[key]) {
          delete params[key];
        }
        if (key === "group1_id") {
          if (userForm[key] && userForm[key].length) {
            params[key] = userForm[key][userForm[key].length - 1];
          } else {
            delete params[key];
          }
        }
        if (key === "time") {
          if (userForm[key] && userForm[key].length) {
            params.time_start = userForm[key][0];
            params.time_end = userForm[key][1];
            delete params[key];
          } else {
            delete params[key];
          }
        }
      });
      params.is_staff = 0;
      let loadingInstance = addLoading(".user-table");
      try {
        let {
          data
        } = await getUserListApi(params);
        total.value = data.total;
        userList.value = data.data;
      } catch {} finally {
        loadingInstance.close();
        userTableFirst.value = false;
      }
    }
    getSourceGroup();
    async function getSourceGroup() {
      try {
        let res = await getSourceGroupApi();
        sourceGroupList.value = res.data;
      } catch {}
    }
    function handleClearSearch() {
      userForm.openid = "";
      userForm.group1_id = [];
      userForm.mobile = "";
      userForm.time = [];
      userForm.is_staff = 0;
      userForm.time_type = null;
      page.page = 1;
      getUserList();
    }
    //以/切割
    function get_source_info(source_info) {
      let arr = source_info.split("/");
      return arr;
    }
    function restUserList() {
      page.page = 1;
      getUserList();
    }
    function handleUserSearch() {
      if (userForm.time_type && (!userForm.time || !userForm.time.length)) {
        ElMessage.warning("请选择时间");
        return;
      }
      restUserList();
    }
    function timeTypeClear() {
      userForm.time = [];
    }
    async function handleUserTableItemParentInfo(item) {
      parentDialogData.value = {};
      parentLoading.value = true;
      try {
        let res = await getParentInfoApi(item.id);
        if (!res.data) {
          // ElMessage.warning('暂未查询到上级信息~')
          parentDialogData.value = {};
          return;
        }
        parentDialogData.value = res.data;
        // parentDialogData.value = {
        //   nickname: "我",
        //   realname: "哈哈哥",
        //   mobile: "18438628516",
        //   user_mobile: "15381153507"
        // }
        // parentDialogVisible.value = true
      } catch {} finally {
        parentLoading.value = false;
      }
    }
    function handleCloseParentMessageDialog() {
      parentDialogVisible.value = false;
      parentDialogData.value = {};
    }
    function handleUserTableItem(item) {
      userDialogVisible.value = true;
      userDialogData.value = item;
    }
    function handleCloseUserDialog() {
      userDialogVisible.value = false;
    }
    function handleUserTableCurrentChange(val) {
      page.page = val;
      getUserList();
    }
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_cascader = _resolveComponent("el-cascader");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_popover = _resolveComponent("el-popover");
      const _component_el_table = _resolveComponent("el-table");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_form, {
        inline: true,
        model: userForm,
        class: "demo-form-inline"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "OPENID"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            style: {
              "width": "180px"
            },
            modelValue: userForm.openid,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => userForm.openid = $event),
            placeholder: "请输入OPENID",
            clearable: ""
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "手机号码"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            style: {
              "width": "180px"
            },
            modelValue: userForm.mobile,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => userForm.mobile = $event),
            placeholder: "请输入手机号码",
            clearable: ""
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "来源"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_cascader, {
            modelValue: userForm.group1_id,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => userForm.group1_id = $event),
            options: sourceGroupList.value,
            clearable: "",
            props: cascaderProps
          }, null, 8, ["modelValue", "options"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "时间筛选"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            onClear: timeTypeClear,
            modelValue: userForm.time_type,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => userForm.time_type = $event),
            clearable: "",
            placeholder: "请选择搜索类型",
            style: {
              "width": "150px",
              "margin-right": "5px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "访问时间",
              value: 1
            }), _createVNode(_component_el_option, {
              label: "授权时间",
              value: 2
            })]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_date_picker, {
            disabled: !userForm.time_type,
            style: {
              "width": "230px"
            },
            modelValue: userForm.time,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => userForm.time = $event),
            type: "datetimerange",
            "start-placeholder": "开始时间",
            "end-placeholder": "结束时间",
            format: "YYYY/MM/DD HH:mm:ss",
            "value-format": "YYYY-MM-DD HH:mm:ss",
            clearable: ""
          }, null, 8, ["disabled", "modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            onClick: handleClearSearch
          }, {
            default: _withCtx(() => [_createTextVNode("重置")]),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            onClick: handleUserSearch
          }, {
            default: _withCtx(() => [_createTextVNode("搜索")]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])]), _createElementVNode("div", _hoisted_4, [!userTableFirst.value ? (_openBlock(), _createBlock(_component_el_table, {
        key: 0,
        data: userList.value,
        "header-cell-style": {
          background: '#F7F9FB !important',
          color: '#111111',
          height: '42px',
          fontSize: '14px'
        }
      }, {
        empty: _withCtx(() => [_hoisted_19]),
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "id",
          label: "用户Id",
          width: "150px",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          label: "openId"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_popover, {
            placement: "bottom",
            trigger: "click",
            width: 270,
            content: scope.row.openid
          }, {
            reference: _withCtx(() => [_createVNode(_component_el_link, {
              type: "primary"
            }, {
              default: _withCtx(() => [_createTextVNode("查看")]),
              _: 1
            })]),
            _: 2
          }, 1032, ["content"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "mobile",
          label: "手机号码",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          label: "上级信息"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_popover, {
            placement: "bottom",
            trigger: "click",
            width: 270
          }, {
            reference: _withCtx(() => [_createVNode(_component_el_link, {
              type: "primary",
              onClick: $event => handleUserTableItemParentInfo(scope.row)
            }, {
              default: _withCtx(() => [_createTextVNode("查看")]),
              _: 2
            }, 1032, ["onClick"])]),
            default: _withCtx(() => [!parentLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_5, [Object.keys(parentDialogData.value).length ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, _toDisplayString(parentDialogData.value.nickname), 1)]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", _hoisted_11, _toDisplayString(parentDialogData.value.realname), 1)]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, _toDisplayString(parentDialogData.value.mobile), 1)])], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_15, " 暂无上级信息 "))])) : _createCommentVNode("", true)]),
            _: 2
          }, 1024)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "来源"
        }, {
          default: _withCtx(scope => [!scope.row.source || scope.row.source && !scope.row.source.length ? (_openBlock(), _createElementBlock("div", _hoisted_16, "-")) : (_openBlock(), _createElementBlock("div", _hoisted_17, [_createTextVNode(_toDisplayString(scope.row.source[0].group2_name) + "/" + _toDisplayString(scope.row.source[0].group1_name) + "/" + _toDisplayString(scope.row.source[0].name) + "/", 1), _createElementVNode("span", _hoisted_18, _toDisplayString(scope.row.source[0].source_type_txt), 1)]))]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "ct_time",
          label: "授权时间",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          prop: "last_time",
          label: "最近访问时间"
        }), _createVNode(_component_el_table_column, {
          label: "操作"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_link, {
            type: "primary",
            onClick: $event => handleUserTableItem(scope.row)
          }, {
            default: _withCtx(() => [_createTextVNode("设为分销人员")]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])) : _createCommentVNode("", true), _createVNode(protoPagination, {
        page: page,
        total: total.value,
        onCurrentChange: handleUserTableCurrentChange
      }, null, 8, ["page", "total"])]), _createVNode(userDialog, {
        "dialog-visible": userDialogVisible.value,
        "item-data": userDialogData.value,
        "source-group-list": sourceGroupList.value,
        onCloseDialog: handleCloseUserDialog,
        onRestData: restUserList
      }, null, 8, ["dialog-visible", "item-data", "source-group-list"]), _createVNode(parentMessageDialog, {
        "dialog-visible": parentDialogVisible.value,
        "item-data": parentDialogData.value,
        onCloseDialog: handleCloseParentMessageDialog
      }, null, 8, ["dialog-visible", "item-data"])]);
    };
  }
});